import { render } from "./VideoPlayComponent.vue?vue&type=template&id=fcee0df2"
import script from "./VideoPlayComponent.vue?vue&type=script&lang=js"
export * from "./VideoPlayComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__